import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SideNavigationService {
  private openSidenav$ = new Subject<string>();
  sidenav$ = this.openSidenav$.asObservable();

  open(seletedSideTab: string) {
    console.log('Service emitting:', seletedSideTab);
    this.openSidenav$.next(seletedSideTab);
  }
}